import { createContext } from 'react';

const AlbumContext = createContext(null);
export default AlbumContext;